//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockCountMenu', {
//        templateUrl: 'views/components/views/stockCountMenu/stockCountMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'stockCountMenuService', function ($stateParams, stateService, translateService, modalService, stockCountMenuService) {

//            // #region VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let stockCountKeyno = $stateParams.stockcount_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                menu: {},
//                approving: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL
            
//            async function loadMenu() {
//                vm.model.menu = (await stockCountMenuService.getMenu({ stockcount_keyno: stockCountKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//    		// #region APPROVE BUTTON FUNCTION
    		
//            vm.approveChanges = function () {
//                vm.model.approving = true;
                
//                stockCountMenuService.approveCounting(vm.model.menu).then(() => {
//                    vm.model.approving = false;
//                    loadMenu();
//                }, () => vm.model.approving = false);
//            }

//            // #endregion APPROVE BUTTON FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'stockcountapprove':
//                        go({ stockcount_keyno: vm.model.menu.stockcount_keyno });
//                        break;
//                    case 'dataMining':
//                        stockCountMenuService.fetchDataMiningItem(vm.model.menu).then(function (response) {
//                            state = response[0].item_state;
                            
//                            go(response[0].item_parms);
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    stockCountMenuService.deleteItem(vm.model.menu).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
